import React, { ReactElement } from 'react'
import { Flex, Stack } from '@mindfulchefuk/design-system'
import { OnboardingChooseRecipesCalendarFilter } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesFilters/OnboardingChooseRecipesCalendarFilter/OnboardingChooseRecipesCalendarFilter'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingChooseRecipesMealPlanFilter } from './OnboardingChooseRecipesMealPlanFilter'
import { OnboardingChooseRecipesPortionCountFilter } from './OnboardingChooseRecipesPortionCountFilter'
import { OnboardingChooseRecipesSortFilter } from './OnboardingChooseRecipesSortFilter/OnboardingChooseRecipesSortFilter'

export const OnboardingChooseRecipesFilters = (): ReactElement => {
  const {
    expandedRecipeFilter,
    mealPlan,
    handleUpdateMealPlan,
    handleUpdatePortionCount,
    handleUpdateDate,
    selectedDeliveryDate,
    unavailableDeliveryDates,
    firstAvailableDeliveryDate,
    lastAvailableDeliveryDate,
    selectedSortBy,
    handleUpdateSortBy,
    toggleRecipeFilter,
    selectedPortionCount,
  } = useChooseRecipesContext()

  return (
    <Flex
      display={{ base: 'block', md: 'flex' }}
      justify="space-between"
      my={16}
      data-testid="choose-recipes-filter-group"
    >
      <Stack direction={['column', 'row', 'row']} spacing={[12, 40, 32]}>
        <OnboardingChooseRecipesMealPlanFilter
          isOpen={expandedRecipeFilter === 'food-groups'}
          mealPlan={mealPlan}
          onChange={(plan) => handleUpdateMealPlan(plan)}
          onToggle={() => toggleRecipeFilter('food-groups')}
        />

        <OnboardingChooseRecipesCalendarFilter
          date={selectedDeliveryDate}
          isOpen={expandedRecipeFilter === 'calendar'}
          onChange={(date: Date) => handleUpdateDate(date)}
          onToggle={() => toggleRecipeFilter('calendar')}
          unavailableDates={unavailableDeliveryDates}
          firstAvailableDeliveryDate={firstAvailableDeliveryDate}
          lastAvailableDeliveryDate={lastAvailableDeliveryDate}
        />

        <OnboardingChooseRecipesPortionCountFilter
          isOpen={expandedRecipeFilter === 'portion-count'}
          onChange={(portionCount) => handleUpdatePortionCount(portionCount)}
          onToggle={() => toggleRecipeFilter('portion-count')}
          portionCount={selectedPortionCount}
        />
      </Stack>
      <Flex justifyContent={{ md: 'flex-end' }} mt={{ base: 12, md: 0 }}>
        <OnboardingChooseRecipesSortFilter
          isOpen={expandedRecipeFilter === 'sort-by'}
          onChange={(sortBy) => handleUpdateSortBy(sortBy)}
          onToggle={() => toggleRecipeFilter('sort-by')}
          recipesSortedBy={selectedSortBy}
        />
      </Flex>
    </Flex>
  )
}
